import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import Thxbg from '../images/自我肯定-350.gif';
import '../css/answer.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share';
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

export default class Answer extends Component {
  constructor() {
    super();
    this.state = {
      Reviews: '',
      ans: '',
      createDate: '',
      createTime: '',
      id: '',
      FoodId: '',
      name: '',
      url: '',
      localUrl: '',
      nextUrl: '',
      loading: false,
      listOfPositions: [],
      listOfFoodPositions: [],
      FoodOtherTag1: false,
      FoodOtherTag2: false,
      FoodOtherTag3: false,
      report: '測驗結果空白',
      otherInfo: '',
      send: false,
      thumb: '',
      iGonnaSay: false,
      toBeMaster: false,
      userId: '',
      masterSay: '',
      MasterBox: false
    }
    this.handleChangeOtherInfo = this.handleChangeOtherInfo.bind(this);
    this.handleReportChange = this.handleReportChange.bind(this);
    this.handleReportSave = this.handleReportSave.bind(this);
    this.handleHasReport = this.handleHasReport.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleIGonnaSay = this.handleIGonnaSay.bind(this);
    this.handleMasterSaySave = this.handleMasterSaySave.bind(this);
    this.handleCancelToBeMaster = this.handleCancelToBeMaster.bind(this);
    this.handleChangeMasterSay = this.handleChangeMasterSay.bind(this);
    this.handleCancelMasterSay = this.handleCancelMasterSay.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  componentDidMount(id) {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {

      if(user) {
        var userId = firebase.auth().currentUser.uid
        const getUserDisplayNameRef = firebase.database().ref('users/').child(userId).child('UserProfile');
        getUserDisplayNameRef.on('value', snap => {
          this.setState({
            email: snap.val().email,
            displayName: snap.val().displayName,
            photoURL: snap.val().photoURL
          })
        })
        const checkWhatCanDoRef = firebase.database().ref('medicalTeam/').child(userId);
        checkWhatCanDoRef.on('value', snap => {
          this.setState({
            youCanDo: snap.val().youCanDo
          })
        })

        let id = this.props.match.params.id;
        const quizRef = firebase.database().ref('users/').child(userId).child('Answers').orderByChild('id').equalTo(id)
        quizRef.on('value', snap => {
          snap.forEach((child) => {
            this.setState({
              testName: child.val().name,
              Reviews: child.val().Reviews,
              ans: child.val().ans,
              createTime: child.val().createTime,
              createDate: child.val().createDate,
              thumb: child.val().thumb,
              url: child.val().url,
              localUrl: child.val().localUrl
            })
            if(this.state.localUrl === '/Table1') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('亞健康').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description
                     })
                     this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table2"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table2') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('過勞').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description
                     })
                     this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table3"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table3') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('自我肯定').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table4"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table4') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('失眠').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table5"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table5') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('壓力').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table6"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table6') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('憂鬱').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table7"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table7') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('尼古丁').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table8"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table8') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('趴趴熊').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "Table9"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/Table9') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('飲食').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable1"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable1') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('平和質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable2"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable2') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('氣虛質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable3"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable3') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('陽虛質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable4"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable4') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('陰虛質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable5"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable5') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('痰濕質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable6"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable6') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('濕熱質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable7"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable7') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('血瘀質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable8"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable8') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('氣鬱質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                    })
                    this.setState({
                      listOfPositions: previousList.reverse(),
                      nextUrl: "CMTable9"
                    })
                  })
               })
            }
            if(this.state.localUrl === '/CMTable9') {
              const checkRef1 = firebase.database().ref('MedicalTeamPosts/').orderByChild('secondTag').equalTo('特稟質').limitToLast(12);
              checkRef1.on('value', snap => {
                  snap.forEach((childSnap) => {
                    const previousList = this.state.listOfPositions;
                    previousList.push({
                      blogName: childSnap.val().blogName,
                      blogTag: childSnap.val().blogTag,
                      secondTag: childSnap.val().secondTag,
                      listPhoto: childSnap.val().listPhoto ? childSnap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
                      id: childSnap.val().id,
                      name: childSnap.val().name,
                      description: childSnap.val().description,
                      nextUrl: "Table1"
                     })
                     this.setState({
                      listOfPositions: previousList.reverse()
                    })
                  })
               })
            }
          })

        })

      } else {
        window.location = ('/')
      }

      
    })
  }
  handleChangeOtherInfo(e) {
    this.setState({
      otherInfo: e.target.value
    })
  }
  handleChangeMasterSay(e) {
    this.setState({
      masterSay: e.target.value
    })
  }
  handleReportChange(e) {
    this.setState({report: e.target.value});
  }
  handleReportSave(e) {
    e.preventDefault();
    // window.location = ('/UserProfile/DetectionRecord');

    const reportRef = firebase.database().ref('reports/').push()
    const reportId = reportRef.key
    reportRef.update({
      localUrl: this.state.localUrl,
      report: this.state.report,
      repeatstate: '未處理',
      email: this.state.email,
      displayName: this.state.displayName,
      photoURL: this.state.photoURL,
      otherInfo: this.state.otherInfo,
      createDate: new Date().toLocaleDateString(),
      createTime: new Date().toLocaleTimeString(),
      id: reportId
    })
    this.setState({ send: true})
    setTimeout(() => this.setState({ loading: true }), 400);
  }
  handleHasReport() {
    this.setState({
      hasReport: true
    })
  }
  handleCancel(){
    this.setState({
      hasReport: false
    })
  }
  handleIGonnaSay() {
      if(this.state.youCanDo != null) {
        this.setState({MasterBox: true})
      } else {
        this.setState({toBeMaster: true})
      }
  }
  handleClose() {
    this.setState({toBeMaster: false})
  }
  handleCancelToBeMaster() {
    this.setState({toBeMaster: false})
  }
  handleCancelMasterSay() {
    this.setState({MasterBox: false})
  }
  handleMasterSaySave(e) {
     e.preventDefault()
     const userId = firebase.auth().currentUser.uid;
     const masterSayRef = firebase.database().ref('masterSay/').push();
     const masterSayKey = masterSayRef.key
     masterSayRef.update({
       id: masterSayKey,
       masterSay: this.state.masterSay,
       userId: userId,
       localUrl: this.state.localUrl,
       pass: 'no'
     })
     this.setState({ send: true})
     setTimeout(() => this.setState({ loading: true }), 400);
  }
  render() {

    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9', padding: 30, minHeight: '100vh', height: 'auto',justifyContent: 'center', alignItems:'center'}} >
      <div>
        <img src={Thxbg} alt="謝謝您" />
        <p style={{textAlign: 'center'}} >回報已送出， 謝謝您提供寶貴資訊。</p>
        <Link to={this.state.localUrl} className="btnDefault">再玩一次</Link>
        <Link to="/UserProfile/DetectionRecord" className="btnDefault">查看體質分析</Link>
        <Link to="/" className="btnDefault">離開</Link>
      </div>
    </div>
    }
    const listOfPositions = this.state.listOfPositions.map(position =>
      <div key={position.id} className="postBox">
               <sub><span>{position.createDate}</span> <span>{position.createTime}</span></sub>
               <Link to={"/AuthorityBlogs/" + position.id} target="_blank">
                <h1>{ position.blogName }</h1>
                <div className="postListBox">
                 <img
                   src={position.listPhoto}
                   alt={position.blogTag}
                 />
                </div>
               </Link>
               <sub className="postListTagsBox">
                <Link to={"/AuthorityTag/" + position.blogTag} target="_blank">{ position.blogTag }</Link>
                <Link to={"/AuthorityTags/" + position.secondTag} target="_blank">{ position.secondTag }</Link>
                <Link to={"/AuthorityTagsa/" + position.otherTag1} style={{display: position.otherTag1 ? 'inline-block' : 'none'}} target="_blank">{ position.otherTag1 }</Link>
                <Link to={"/AuthorityTagsb/" + position.otherTag2} style={{display: position.otherTag2 ? 'inline-block' : 'none'}} target="_blank">{ position.otherTag2 }</Link>
               </sub>
               <sub style={{padding: '0 0 0 7px'}}>
                <a href={this.state.theAuthor} target="_blank" rel="noopener noreferrer" className="author" style={{display:'block', margin: '5px 0 -2px 0'}}>作者: {this.state.name}</a>
                <span>{this.state.createDate}</span> <span>{this.state.createTime}</span>
               </sub>
           </div>
   )

    const loderThumbBox = this.state.thumb
     ? <img src={this.state.thumb} alt={this.state.name} className="thumbPhoto"/>
     : null

    return(
      <div className="container hasPadding">
       <MetaTags>
            <title>草學藥事 || {this.state.name}檢測結果</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
            <meta id="og-image" property="og:image" content={this.state.thumb} />
            <meta property="og:image" content={this.state.thumb} />
        </MetaTags>
       <div className="ansBox">
         <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 hasnoMar">
           <div className="tableThuumb">
            {loderThumbBox}
           </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-8 col-lg-8">
           <article className="ansBoxInfo" >
            <h1>{this.state.testName}</h1>
            <p style={Jeyu.answer}>檢測結果: {this.state.ans}分</p>
            <pre>{this.state.Reviews}</pre>
            <div>
             <Link to="/UserProfile/DetectionRecord" className="btnDefault" target="_blank">查看體質分析</Link>
             <span onClick={this.handleIGonnaSay} className="btnDefault" style={{background: '#23c7c9'}} target="_blank">達人有話要說</span>
             <div className="lightBox" style={{display: this.state.MasterBox ? 'flex' : 'none'}}>
              <form onSubmit={this.handleMasterSaySave} className="reportBox">
               <label htmlFor="masterSay" style={{marginTop: 10}}>達人請說說更好的建議:</label>
               <textarea id="masterSay" value={this.state.masterSay} onChange={this.handleChangeMasterSay}> </textarea>
               <input type="submit" value="送出" className="btnDefault" />
               <span className="btnDefault" onClick={this.handleCancelMasterSay}>取消</span>
              </form>
             </div>
             <div className="lightBox" style={{display: this.state.toBeMaster ? 'flex' : 'none'}}>
              <form className="reportBox">
               <p>您已經有達人的權限, 但還沒正式開通喔!!<br />
                 寫下自己的介紹,儲存後即可開通達人權限,同時享有更多達人的權力
               </p>
               <Link to="/UserProfile/AuthorityDashbord" target="_balnk" className="btnDefault" onClick={this.handleClose} >立即前往開通吧</Link>
               <span className="btnDefault" onClick={this.handleCancelToBeMaster}>取消</span>
              </form>
             </div>
            </div>
            <div style={{marginTop: 10}} >
             <Link to={this.state.localUrl} className="btn-gray">再玩一次</Link>
             <a href={'https://herbalcure.com.tw/' + this.state.nextUrl} className="btn-gray">下一個測驗</a>
             <span className="btn-gray" onClick={this.handleHasReport}>回報問題</span>
             <div className="lightBox" style={{display: this.state.hasReport ? 'flex' : 'none'}}>
              <form onSubmit={this.handleReportSave} className="reportBox">
               <select value={this.state.report} onChange={this.handleReportChange} >
                <option value="測驗結果空白">測驗結果空白</option>
                <option value="測驗結果不準">測驗結果不準</option>
                <option value="工程師好帥">工程師好帥</option>
               </select>
               <label htmlFor="otherInfo" style={{marginTop: 10}}>其他</label>
               <textarea id="otherInfo" value={this.state.otherInfo} onChange={this.handleChangeOtherInfo}> </textarea>
               <input type="submit" value="送出" className="btnDefault" />
               <span className="btnDefault" onClick={this.handleCancel}>取消</span>
              </form>
             </div>
            </div>
           </article>
           <p>分享量表給朋友測驗吧:</p>
           <article className="fbBox">
                <div className="Demo__some-network">
                   <FacebookShareButton
                     url={'https://herbalcure.com.tw/'+this.state.localUrl}
                     quote={this.state.name}
                     className="Demo__some-network__share-button">
                     <FacebookIcon
                       size={26}
                       round />
                   </FacebookShareButton>
                 </div>
                 <div className="Demo__some-network">
                   <GooglePlusShareButton
                     url={'https://herbalcure.com.tw/'+this.state.localUrl}
                     className="Demo__some-network__share-button">
                     <GooglePlusIcon
                       size={26}
                       round />
                   </GooglePlusShareButton>
                 </div>
           </article>
          </div>
         </div>
       </div>
        <section>
         <h3>相關文章:</h3>
         <article className="answerFlex">
           {listOfPositions}
         </article>
        </section>
      </div>
    )
  }
}

const Jeyu = {
  answer: {
    color: '#325aaa',
    fontSize: 28,
    fontWeight: 'bold', 
    margin: 0
  },
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  },
  hasPadding: {
    padding: '25px 15px'
  },
  Center: {
    textAlign: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/Answer.js